import { render } from "./PlaceholderView.vue?vue&type=template&id=46f62fec&scoped=true"
import script from "./PlaceholderView.vue?vue&type=script&lang=js"
export * from "./PlaceholderView.vue?vue&type=script&lang=js"

import "./PlaceholderView.vue?vue&type=style&index=0&id=46f62fec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46f62fec"]])

export default __exports__